import React from "react";
import StockList from "./StockList";

/**
 * Thin wrapper kept for backwards-compatibility with `Dashboard.jsx`. The
 * old card-grid implementation has been replaced by the universal
 * `StockList` (row-based, click-opens-modal) for consistency across all
 * scanner tabs.
 */
export function ColumnSection({
  title, subtitle, items, loading, onOpen, onWatch, watchedSet, freshSet, testid,
}) {
  return (
    <StockList
      title={title}
      subtitle={subtitle}
      items={items}
      loading={loading}
      onOpen={onOpen}
      onWatch={onWatch}
      watchedSet={watchedSet}
      freshSet={freshSet}
      testid={testid}
      testIdPrefix="breakout-row"
      emptyMessage="No breakouts match current filters."
      rowProps={(s) => ({
        scoreKey: undefined, // breakouts use strength badge instead of score
        typeBadge:
          s.strength === "Strong"
            ? { label: "Strong", tone: "pos" }
            : { label: s.strength || "—", tone: "mod" },
      })}
    />
  );
}
